"use strict";

const SPORT_COMBAT = "combat";
const SPORT_STICK = "stick";
const SPORT_RUGBY = "rugby";
const SPORT_GENERIC = "generic";

let sportCombatID = document.getElementById("sport-combat-id");
let sportStickID = document.getElementById("sport-stick-id");
let sportRugbyID = document.getElementById("sport-rugby-id");
let sportGenericID = document.getElementById("sport-generic-id");

let sportSelectedImageID = document.getElementById("sport-selected-image-id");
let sportSelectedHeadingID = document.getElementById("sport-selected-heading-id");
let sportSelectedTextID = document.getElementById("sport-selected-text-id");

let sportBiolanID = document.getElementById("sport-biolan-visible-checkbox-id");		// used to show and hide the biolan checkbox	
let sportBiolanLabelID = document.getElementById("sportBiolanLabelID");					// used to show and hide the biolan label
let sportBiolanCheckbox = document.getElementsByClassName("sport-biolan-input")[0];		// used to toggle the biolan checkbox off (ie. untick it)

sportCombatID.addEventListener("click", clickedOnCombat);
sportStickID.addEventListener("click", clickOnStick);
sportRugbyID.addEventListener("click", clickedOnRugby);
sportGenericID.addEventListener("click", clickedOnGeneric);

// set the default sport to combat
clickedOnCombat();

// set the sport to combat being selected
function clickedOnCombat() {
  $('.sport-dial').removeClass('active');
  $('#sport-combat-id').addClass('active');
   var bg = $('#sport-combat-id').css('background-image');
    bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
    sportSelectedImageID.setAttribute(
        "src",
        bg
    );
    sportSelectedImageID.setAttribute("alt", "Combat Sports");
    sportSelectedHeadingID.innerHTML = "Boxing - MMA - Martial Arts";
    sportSelectedTextID.innerHTML = `<p class="sport-choice-format">This is for all you pugilists and martial artists - gobsmacking protection from each other!
		The combat mouthguard range covers you from light sparring training sessions up to full pro level competition fights. There are two options available:</p>
		<p class="sport-choice-format"><strong>HIGH PROTECTION</strong> - is approximately 3mm in thickness, less bulk and very comfortable in the mouth whilst providing more 
		than adequate protection for everyday training especially for younger athletes.</p>
		<p class="sport-choice-format"><strong>PRO PROTECTION</strong> - is approximately 4.5mm in thickness. Whilst it still 
		allows for natural speech and easy breathing without falling out, it also provides superior protection for those unforgiving circumstances.</p>
		<p class="sport-choice-format">If you&rsquo;re unsure, a good guideline to follow is if you do interclub, or competition fights – 
		get the Pro. If you&rsquo;re training hard but not into competitive events – get the High.</p>`;

    sportCombatID.style.border = "3px solid var(--darkOrange)";
    sportCombatID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    sportCombatID.style.fontWeight = "bold";
    document.documentElement.style.setProperty("--sport-combat-text-col", "rgb(245, 139, 30)");
  
  	// turn off the biolan isert option
  	sportBiolanCheckbox.checked = false;
  	sportBiolanID.style.display = "none";
  	sportBiolanLabelID.style.display = "none";

    // reset the other sports thumbnails
    resetNonSelectedSports(SPORT_COMBAT);
}

// set the sport to stick being selected
function clickOnStick() {
  $('.sport-dial').removeClass('active');
 $(this).addClass('active');
   var bg = $(this).css('background-image');
   bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
    sportSelectedImageID.setAttribute(
        "src",
        bg
    );
    sportSelectedImageID.setAttribute("alt", "Stick Sports");
    sportSelectedHeadingID.innerHTML = "Lacrosse - Hockey - Ice Hockey";
  // INCLUDES BIOLON OPTION IN TEXT
  //   sportSelectedTextID.innerHTML = `<p class="sport-choice-format">This is for sports with weapons! Hockey, Lacrosse, or anything else that can accidently smack you 
		// in the teeth, which will likely cause severe damage. The protection level options are:</p>
		// <p class="sport-choice-format"><strong>HIGH PROTECTION</strong> - is approximately 3mm in thickness and very comfortable in the mouth. Due to the nature of
		// these sports using hard sticks, this level of protection is not recommended for anything other than light training sessions except for younger players where the thicker Pro will be less comfortable.</p>
		// <p class="sport-choice-format"><strong>PRO PROTECTION</strong> - is approximately 4.5mm in thickness therefore bulkier in the mouth and provides the greater protection required for these sports. 
		// As such, this is what we would recommend as a minimum when engaging in anything competitive. Even though this mouthguard is bigger
		// in the mouth it is still comfortable for adult use, allows for natural speech and easy breathing, while also providing the extra needed protection.</p>
		// <p class="sport-choice-format"><strong>BIOLON INSERT</strong> - For these unforgiving sports we have an extra level of protection that adds
		// an additional hard insert that covers from canine to canine. This insert further disperses impact energy over a greater area of the mouthguard 
		// to provide substantially more protection to your front teeth.</p>
		// <p class="sport-choice-format">One thing to note about adding the Biolon insert is that the aethetics of the mouthguard will not be as pleasing, so we only recommend
		// adding this when the highest level of protection is required.</p>`;

  // NO BIOLON OPTION IN TEXT
    sportSelectedTextID.innerHTML = `<p class="sport-choice-format">This is for sports with weapons! Hockey, Lacrosse, or anything else that can accidently smack you 
		in the teeth, which will likely cause severe damage. The protection level options are:</p>
		<p class="sport-choice-format"><strong>HIGH PROTECTION</strong> - is approximately 3mm in thickness and very comfortable in the mouth. Due to the nature of
		these sports using hard sticks, this level of protection is not recommended for anything other than light training sessions except for younger players where the thicker Pro will be less comfortable.</p>
		<p class="sport-choice-format"><strong>PRO PROTECTION</strong> - is approximately 4.5mm in thickness therefore bulkier in the mouth but provides the greater protection required for these sports. 
		As such, this is what we would recommend as a minimum when engaging in anything competitive. Even though this mouthguard is bigger
		in the mouth it is still comfortable for adult use, allows for natural speech and easy breathing, while also providing the extra needed protection.</p>`;

    sportStickID.style.border = "3px solid var(--darkOrange)";
    sportStickID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    sportStickID.style.fontWeight = "bold";
    document.documentElement.style.setProperty("--sport-stick-text-col", "rgb(245, 139, 30)");
  
   	// turn on the biolan isert option
  	sportBiolanCheckbox.checked = false;
  	sportBiolanID.style.display = "block";
  	sportBiolanLabelID.style.display = "block";

    // reset the other sports thumbnails
    resetNonSelectedSports(SPORT_STICK);
}

// set the sport to rugby being selected
function clickedOnRugby() {
   $('.sport-dial').removeClass('active');
 $(this).addClass('active');
   var bg = $(this).css('background-image');
   bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
    sportSelectedImageID.setAttribute(
        "src",
        bg
    );
    sportSelectedImageID.setAttribute("alt", "Football Sports");
    sportSelectedHeadingID.innerHTML = "Rugby Football - Aussie Rules Football - American Football";
  // INCLUDES BIOLON OPTION IN TEXT
  //   sportSelectedTextID.innerHTML = `<p class="sport-choice-format">This section caters for sports where heavy body contact and stamping studs meet, such as 
		// the different types of Rugby, Aussie Rules Football, American Football, and other similar variations. The protection level options are:</p>
		// <p class="sport-choice-format"><strong>HIGH PROTECTION</strong> - is approximately 3mm in thickness and very comfortable in the mouth, especially for younger players. As with the Sticks section
		// we only recommend this level of protection for light training sessions. A possible exception to this would be for American Football, as this level of protection 
		// fits in well with the existing use of helmets and face guards.</p>
		// <p class="sport-choice-format"><strong>PRO PROTECTION</strong> - is approximately 4.5mm in thickness, bulkier in the mouth but provides the greater protection required for these sports. 
		// As such, this is what we would recommend as a minimum when engaging in anything competitive. Even though this mouthguard is bigger
		// in the mouth it is still comfortable, allows for natural speech and easy breathing, while also providing the extra needed protection.</p>
		// <p class="sport-choice-format"><strong>BIOLON INSERT</strong> - Since these sports have high impact situations involving heads, studs and faces we’d recommend 
		// adding the hard biolon insert for extra protection – this will add a little bit extra thickness to the front but will spread an impact more uniformly.</p>
		// <p class="sport-choice-format">One thing to note about adding the Biolon insert is that the aethetics of the mouthguard will not be as pleasing, so we only recommend
		// adding this when the highest level of protection is required.</p>`;

  // NO BIOLON OPTION IN TEXT
    sportSelectedTextID.innerHTML = `<p class="sport-choice-format">This section caters for sports where heavy body contact and stamping studs meet, such as 
		the different types of Rugby, Aussie Rules Football, American Football, and other similar variations. The protection level options are:</p>
		<p class="sport-choice-format"><strong>HIGH PROTECTION</strong> - is approximately 3mm in thickness and very comfortable in the mouth espeically for younger players. As with the Sticks section
		we only recommend this level of protection for light training sessions. A possible exception to this would be for American Football, as this level of protection 
		fits in well with the existing use of helmets and face guards.</p>
		<p class="sport-choice-format"><strong>PRO PROTECTION</strong> - is approximately 4.5mm in thickness and provides the greater protection required for these sports. 
		As such, this is what we would recommend as a minimum when engaging in anything competitive. Even though this mouthguard is bigger
		in the mouth it is still comfortable, allows for natural speech and easy breathing, while also providing the extra needed protection.</p>`;  

    sportRugbyID.style.border = "3px solid var(--darkOrange)";
    sportRugbyID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    sportRugbyID.style.fontWeight = "bold";
    document.documentElement.style.setProperty("--sport-rugby-text-col", "rgb(245, 139, 30)");
  
    // turn on the biolan isert option
  	sportBiolanCheckbox.checked = false;
  	sportBiolanID.style.display = "block";
  	sportBiolanLabelID.style.display = "block";

    // reset the other sports thumbnails
    resetNonSelectedSports(SPORT_RUGBY);
}

// set the sport to generic being selected
function clickedOnGeneric() {
   $('.sport-dial').removeClass('active');
 $(this).addClass('active');
   var bg = $(this).css('background-image');
   bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
    sportSelectedImageID.setAttribute("src",bg);
    sportSelectedImageID.setAttribute("alt", "General Sports");
    sportSelectedHeadingID.innerHTML = "Cricket - Baseball - Rounders - Squash - etc.";
    sportSelectedTextID.innerHTML = `<p class="sport-choice-format">We’d love to have a category for every sport but that would be...?!</p> 
		<p class="sport-choice-format">This section is for those of you who play Squash, Basketball, Baseball, Cricket, Horse Riding, even Airsoft games.
		Basically it covers any sport where there is a possibly of tooth avulsion, but the likelyhood of encountering hard impacts is lower. This 
		even caters for sports that traditionally don't use mouthguards.</p>
		<p class="sport-choice-format">Again, like the other catagories we have the following two options:</p>
		<p class="sport-choice-format"><strong>HIGH PROTECTION</strong> - is approximately 3mm in thickness, less bulk and very comfortable in the mouth whilst 
		providing more than adequate protection in general circumstances. As this section is for sports that don't generally involve hard impacts, this is the
		recommended level of protection, especially for younger athletes.</p>
		<p class="sport-choice-format"><strong>PRO PROTECTION</strong> - is approximately 4.5mm in thickness. Whilst it still allows for natural speech and 
		easy breathing without falling out, it provides superior protection in more unforgiving circumstances. Generally, this level of protection would not be required for
		these types of sports, but if you would like the extra peace of mind, you can have it!</p>`;

    sportGenericID.style.border = "3px solid var(--darkOrange)";
    sportGenericID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    sportGenericID.style.fontWeight = "bold";
    document.documentElement.style.setProperty("--sport-generic-text-col", "rgb(245, 139, 30)");
  
    // turn off the biolan isert option
  	sportBiolanCheckbox.checked = false;
  	sportBiolanID.style.display = "none";
  	sportBiolanLabelID.style.display = "none";

    // reset the other sports thumbnails
    resetNonSelectedSports(SPORT_GENERIC);
}

// reset the non selected sport thumbnails to being deselected
function resetNonSelectedSports(currentlySelectedSport) {
    switch (currentlySelectedSport) {
        case SPORT_COMBAT:
            sportRugbyID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportRugbyID.style.boxShadow = "none";
            sportRugbyID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-rugby-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportStickID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportStickID.style.boxShadow = "none";
            sportStickID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-stick-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportGenericID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportGenericID.style.boxShadow = "none";
            sportGenericID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-generic-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
        case SPORT_STICK:
            sportCombatID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportCombatID.style.boxShadow = "none";
            sportCombatID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-combat-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportRugbyID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportRugbyID.style.boxShadow = "none";
            sportRugbyID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-rugby-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportGenericID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportGenericID.style.boxShadow = "none";
            sportGenericID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-generic-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
        case SPORT_RUGBY:
            sportCombatID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportCombatID.style.boxShadow = "none";
            sportCombatID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-combat-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportStickID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportStickID.style.boxShadow = "none";
            sportStickID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-stick-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportGenericID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportGenericID.style.boxShadow = "none";
            sportGenericID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-generic-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
        case SPORT_GENERIC:
            sportCombatID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportCombatID.style.boxShadow = "none";
            sportCombatID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-combat-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportStickID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportStickID.style.boxShadow = "none";
            sportStickID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-stick-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            sportRugbyID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            sportRugbyID.style.boxShadow = "none";
            sportRugbyID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--sport-rugby-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
    }
}
